module.exports = __webpack_public_path__ + "img/company_cert_bg.e8363737.svg";